module.exports = __webpack_public_path__ + "img/Comic03-1.5be0001e.png";